<template>

  <v-dialog width="500" v-model="show">
    <v-card>
      <v-card-title class="headline primary">
        Создание организации
      </v-card-title>
      <v-card-text>

        <v-row>
          <v-col cols="12" class="mt-2">
            <v-text-field
                v-model="newItem.name"
                label="Название организации"
                placeholder="Введите название организации"
                :rules="[rules.required]"
                required
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="12" class="pt-0">
            <v-autocomplete
                v-model="newItem.address"
                :items="suggestions"
                placeholder="Укажите адрес"
                @change="AutocompleteSelectAddress"
                :search-input.sync="search"
                item-text="value"
                item-value="value"
                @keyup="AutocompleteSearchAddress"
                :loading="isLoadingSuggest"
                clearable
                hide-details
                label="Адрес организации"
                class="plcolor"
                :rules="[rules.required]"
                required
                :filter="() => true"
                no-data-text="Начните вводить адрес"
            ></v-autocomplete>
          </v-col>
        </v-row>


      </v-card-text>
      <v-divider>

      </v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="sendForm">Создать</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import axios from 'axios';

export default {
  name: 'OrganizationCreateModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    suggestions: [],
    isLoadingSuggest: false,
    search: '',
    newItem: {
      name: '',
      address: '',
    },
    rules: {
      required: v => !!v || 'Поле должно быть заполнено',
    },
  }),
  mounted() {
    if (this.value) {
      this.newItem.name = this.value;
    }
  },
  methods: {
    clearForm() {
      this.newItem = {
        address: '',
        name: '',
      };
    },
    clearSelectedItem() {
      this.selectedItem = {
        id: '',
        address: '',
        name: '',
      };
      this.$emit('select', {});
    },
    sendForm() {
      const app = this;

      const item = app.newItem;

      return app.$store.getters.ax.post('profiles/api/register/create-dealer', item)
        .then((response) => {
          this.$emit('select', response.data.data);
          this.clearForm();
        }).catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    async AutocompleteSearchAddress(queryString) {
      queryString = this.search;
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      this.isLoadingSuggest = true;
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      await axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
        })
        .catch((err) => {
          console.log(err);
        }).finally(() => {
          this.isLoadingSuggest = false;
        });
    },
    AutocompleteSelectAddress(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          document.getElementById('trade-organization-address').focus();
        }
      });
    },
  },
};
</script>

<style lang="scss">

  .el-autocomplete {
    width: 100%;

    .el-input__inner {
      border: none;
    }
  }

  .edit_icon:hover {
    opacity: 0.7;
  }

</style>
